import type { ReactNode } from 'react';
import { Box } from '@mui/material';

interface OrderListCellProps {
  children: ReactNode;
}

const OrderListCell = ({ children }: OrderListCellProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        minWidth: 0,
        flex: '1 1 auto',
        alignSelf: 'stretch',
        overflow: 'hidden',
        lineHeight: 'normal',
        whiteSpace: 'normal',
      }}
    >
      {children}
    </Box>
  );
};

export default OrderListCell;
